import { apiConstants } from "../../config";
import {
  apiPost,
  apiPut,
  apiGet,
  apiDelete
} from "../../../../shared/services";

const fetchOrderlines = async (options, order_id) => {
  const url = apiConstants.orderLine;
  return await apiGet(url, { params: { ...options, order_id } });
};

const saveOrderline = async (id, data, validator) => {
  if (id) {
    let url = apiConstants.orderLine + "/" + id;
    return await apiPut(url, { ...data }, validator);
  } else {
    let url = apiConstants.orderLine;
    return await apiPost(url, { ...data }, validator);
  }
};

const fetchOrderline = async id => {
  const url = apiConstants.orderLine;
  return await apiGet(url + "/" + id);
};

const deleteOrderline = async id => {
  const url = apiConstants.orderLine;
  return await apiDelete(url + "/" + id);
};

const deleteOrderlineLabel = async id => {
  const url = apiConstants.orderLine;
  return await apiPost(url + "/" + id + "/deletelabel");
};

const reassignOrderlineLabel = async id => {
  const url = apiConstants.orderLine;
  return await apiPost(url + "/" + id + "/reassignlabel");
};

const sendOrderlineLabel = async id => {
  const url = apiConstants.orderLine;
  return await apiPost(url + "/" + id + "/sendlabel");
};

const fetchDoorTypes = async options => {
  const url = apiConstants.doorType;
  return await apiGet(url, {
    params: { page: 1, itemsPerPage: "-1", ...options }
  });
};

const duplicateOrderline = async id => {
  const url = apiConstants.orderLine;
  return await apiPost(url + "/" + id + "/duplicate");
};

const prove = async (id, data, validator) => {
  const url = apiConstants.doorType;
  return await apiPost(url + "/" + id + "/prove", { ...data }, validator);
};

const toogleFavorite = async (id, data, validator) => {
  const url = apiConstants.doorType;
  return await apiPost(
    url + "/" + id + "/tooglefavorite",
    { ...data },
    validator
  );
};

const storeFavorite = async (id, data, validator) => {
  if (id) {
    let url = apiConstants.favorites + "/" + id;
    return await apiPut(url, { ...data }, validator);
  } else {
    let url = apiConstants.favorites;
    return await apiPost(url, { ...data }, validator);
  }
};

export {
  fetchOrderlines,
  saveOrderline,
  deleteOrderline,
  fetchOrderline,
  fetchDoorTypes,
  duplicateOrderline,
  prove,
  toogleFavorite,
  storeFavorite,
  deleteOrderlineLabel,
  reassignOrderlineLabel,
  sendOrderlineLabel
};
